export default __webpack_public_path__ + "static/media/f6.aaa75f45.png";